export default "__VITE_PUBLIC_ASSET__ea510309__"